import settings from './settings';

export default {
  namespaced: true,
  modules: {
    settings
  },
  state: {
    data: []
  },
  getters: {
    columns(state) {
      return state.settings.data.map(i => {
        return {
          value: i,
          text: i
        };
      });
    }
  },

  actions: {
    load({ commit }, params) {
      if (!params) {
        const list = [];
        list.length = 40;
        list.fill({
          id: 1,
          name: 'Name #',
          avatar: '',
          status: 'Enabled',
          'Serviceapp name': 'App #',
          author: 'Name Surname',
          owner: 'Name Surname'
        });
        commit(
          'set',
          list.map((i, n) => {
            return {
              ...i,
              id: i.id + n,
              name: `${i.name}${n}`,
              'Serviceapp name': `${i['Serviceapp name']}${n}`,
              avatar: 'mdi-video-input-component'
            };
          })
        );
        commit(
          'settings/set',
          Object.keys(list[0]).filter(i => i !== 'avatar')
        );
      }
    }
  }
};
